if (!customElements.get('purchase-options')) {
  customElements.define(
    'purchase-options',
    class PurchaseOptions extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form) return;
        this.idInput = this.form.querySelector('input[name="id"]');
        this.planInput = this.form.querySelector('input[name="selling_plan"]');
        if (!this.planInput) {
          this.planInput = document.createElement('input');
          this.planInput.type = 'hidden';
          this.planInput.name = 'selling_plan';
          this.form.appendChild(this.planInput);
        }
        this.submitLabel = this.form.querySelector('.product-form__submit > span');
        // quantity mode cards (data-qty): the form posts N of one variant instead of choosing a variant
        if (this.querySelector('.po-card[data-qty]')) {
          this.qtyInput = this.form.querySelector('input[name="quantity"]');
          if (!this.qtyInput) {
            this.qtyInput = document.createElement('input');
            this.qtyInput.type = 'hidden';
            this.qtyInput.name = 'quantity';
            this.form.appendChild(this.qtyInput);
          }
        }

        this.addEventListener('change', (e) => {
          if (e.target.classList.contains('po-card__radio')) this.select(e.target.closest('.po-card'));
        });
        this.initSubscriptions();
        const initial = this.querySelector('.po-card__radio:checked');
        if (initial) this.select(initial.closest('.po-card'), true);
      }

      // Subscribe & Save toggle: cards with data-sub-items switch to subscription prices, and the form gets a
      // j_sub_items field that j-cart.js turns into the subscription line items (other products + selling plans)
      initSubscriptions() {
        this.mode = 'one';
        this.modeBar = this.querySelector('.po-mode');
        const subCards = [...this.querySelectorAll('.po-card[data-sub-items]')];
        if (!this.modeBar || !subCards.length) return;
        const best = Math.max(...subCards.map((c) => Number(c.dataset.subSave) || 0));
        const bestEl = this.modeBar.querySelector('[data-sub-best]');
        if (bestEl && best > 0) bestEl.textContent = ` · save up to ${best}%`;
        this.modeBar.hidden = false;
        this.querySelectorAll('.po-card').forEach((c) => {
          const q = (sel) => c.querySelector(sel);
          c.dataset.oneBilled = q('.po-card__billed')?.innerHTML || '';
          c.dataset.oneNow = q('.po-card__now')?.textContent || '';
          c.dataset.oneSave = q('.po-card__save')?.textContent || '';
        });
        this.subInput = document.createElement('input');
        this.subInput.type = 'hidden';
        this.subInput.name = 'j_sub_items';
        this.subInput.disabled = true;
        this.form.appendChild(this.subInput);
        this.modeBar.addEventListener('click', (e) => {
          const btn = e.target.closest('.po-mode__btn');
          if (btn) this.setMode(btn.dataset.mode);
        });
      }

      setMode(mode) {
        this.mode = mode;
        const sub = mode === 'sub';
        this.classList.toggle('po--sub', sub);
        // badges marked subscription-only (e.g. "Cancel Anytime") follow the toggle
        (this.closest('product-info, .product, section') || document).querySelectorAll('[data-j-sub-only]').forEach((el) => { el.hidden = !sub; });
        this.modeBar.querySelectorAll('.po-mode__btn').forEach((b) => {
          const on = b.dataset.mode === mode;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on);
        });
        this.querySelectorAll('.po-card').forEach((c) => {
          const has = !!c.dataset.subItems;
          const radio = c.querySelector('.po-card__radio');
          const billed = c.querySelector('.po-card__billed');
          const now = c.querySelector('.po-card__now');
          let save = c.querySelector('.po-card__save');
          if (sub && !has) { c.classList.add('is-disabled', 'po-card--no-sub'); if (radio) radio.disabled = true; return; }
          if (c.classList.contains('po-card--no-sub')) { c.classList.remove('is-disabled', 'po-card--no-sub'); if (radio) radio.disabled = false; }
          if (!has) return;
          if (billed) billed.innerHTML = sub ? c.dataset.subBilled : c.dataset.oneBilled;
          if (now) now.textContent = sub ? c.dataset.subMonth : c.dataset.oneNow;
          const saveText = sub ? (Number(c.dataset.subSave) > 0 ? `Save ${c.dataset.subSave}%` : '') : c.dataset.oneSave;
          if (!save && saveText) {
            save = document.createElement('span');
            save.className = 'po-card__save';
            c.querySelector('.po-card__price')?.prepend(save);
          }
          if (save) { save.textContent = saveText; save.hidden = !saveText; }
          c.querySelectorAll('.po-card__bsave').forEach((el) => {
            if (!el.dataset.one) el.dataset.one = el.textContent;
            el.textContent = sub ? `${c.dataset.subSave}%` : el.dataset.one;
          });
        });
        let card = this.querySelector('.po-card.is-selected');
        if (!card || card.classList.contains('po-card--no-sub')) card = this.querySelector('.po-card[data-sub-items]') || card;
        const r = card?.querySelector('.po-card__radio');
        if (r) r.checked = true;
        if (card) this.select(card, true);
      }

      select(card, initial = false) {
        this.querySelectorAll('.po-card').forEach((c) => c.classList.toggle('is-selected', c === card));
        const { variantId, planId, label, qty } = card.dataset;
        const sub = this.mode === 'sub' && !!card.dataset.subItems;
        const price = sub ? card.dataset.subPrice : card.dataset.price;
        if (this.subInput) {
          this.subInput.value = sub ? card.dataset.subItems : '';
          this.subInput.disabled = !sub;
        }

        this.idInput.value = variantId;
        if (this.qtyInput && qty) this.qtyInput.value = qty;
        this.idInput.disabled = false;
        this.planInput.value = planId || '';
        this.planInput.disabled = !planId;

        if (this.submitLabel && this.dataset.atcLabel) {
          this.submitLabel.textContent =
            this.dataset.atcPrice === 'true' ? `${this.dataset.atcLabel} – ${price}` : this.dataset.atcLabel;
        }

        if (!initial && !qty) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          if (planId) url.searchParams.set('selling_plan', planId);
          else url.searchParams.delete('selling_plan');
          window.history.replaceState({}, '', url.toString());
        }

        document.dispatchEvent(
          new CustomEvent('purchase-options:change', { detail: { variantId, planId, price, label } })
        );
      }
    }
  );
}
